// src/pages/clientes/ClienteCuentaPage.tsx
import { Stack, Typography } from "@mui/material";

/**
 * Placeholder temporal para la zona “Mi cuenta”.
 * Sustitúyelo cuando implementes los ajustes de perfil, etc.
 */
export default function ClienteCuentaPage() {
  return (
    <Stack spacing={2} sx={{ p: 4 }}>
      <Typography variant="h4">Mi cuenta</Typography>
      <Typography variant="body1" color="text.secondary">
        Próximamente podrás gestionar aquí tus datos de perfil, cambiar la contraseña y ver
        estadísticas de tus reservas.
      </Typography>
    </Stack>
  );
}
